<template>
    <div class="absolute top-0 left-0 w-full h-full rounded-lg flex flex-col gap-y-4 overflow-hidden">
        <div class="relative w-full h-full flex flex-col border rounded-lg bg-transparent sm:p-2 p-5 gap-y-5">
            <div class="absolute top-0 left-0 w-full h-full flex flex-col gap-4 p-4">
                <h2 class="text-xl mb-4 text-eblack-950">{{ $t("admin.auto.categorias") }}</h2>

                <div class="w-full flex  justify-between gap-y-5">
                    <button 
                    type="button"
                    class="bg-egreen-400 w-auto text-white py-1.5 px-4 rounded-lg text-md inline-flex justify-center items-center gap-2"
                    @click="addCategory()">
                        <IconCirclePlus stroke={2} />
                        <span>{{ $t("admin.auto.agregar") }}</span>
                    </button>
                    <input 
                    type="text" 
                    name="search"
                    v-model="search" 
                    class="rounded-lg border-eblack-300 text-md sm:w-full md:w-80 focus:ring-blue-500 px-4 py-1.5"
                    @keyup="searchInput()"
                    :placeholder="$t('admin.auto.categoria')">
                </div>
                <div class="w-full max-h-full grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 overflow-y-auto gap-4 pt-6">
                    <div class="flex justify-center" v-for="item in categories_list" v-bind:key="item.id">
                        <CardDropdown 
                        :category="item" 
                        :setCategory="setCategory"
                        :initData="initData"
                        :deleteAddingCategory="deleteAddingCategory"></CardDropdown>
                    </div>
                </div>
            </div>
        </div>
      
    </div>
</template>

<script>
    import { initFlowbite } from 'flowbite';
    import CardDropdown from './components/CardDropdown.vue';
    import categoryRequests from "@/services/admin/category-service";

    export default {
        name:"CategoryIndex",
        data(){
            return {
                category:{
                    id:0,
                    name:""
                },
                search:"",
                categories:[],
                categories_list:[]
            }
        },
        components:{
            CardDropdown
        },
        methods:{
            setCategory(category){
                this.category = category
            },
            setShowModal(value){
                this.showModal = value
            },
            initData(){
                categoryRequests.getAllCategories().then(
                    res => {
                        if(res.status == 200){
                            let {data} = res
                            this.categories = data;
                            this.categories_list = data;
                        }
                    },
                    error => {
                        console.log(error)
                    }
                )
            },
            addCategory(){
                this.categories_list.unshift({
                    id:0,
                    name:""
                })
            },
            deleteAddingCategory(){
                this.categories_list.splice(0,1)
            },
            searchInput(){
                if(this.search){
                    this.categories_list = this.categories.filter(item => item.name.toLowerCase().includes(this.search.toLowerCase()))
                }else{
                    this.categories_list = this.categories
                }
            }
        },
        mounted(){
            initFlowbite()
            this.initData()
        }
    }
</script>

<style lang="scss" scoped>

</style>